/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Badge, Box, Button, Divider, Icon, IconButton, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import { clearUnreadCount, deleteNotification, resetAnchorEl, setAnchorEl, setNotifications } from "ReduxReducers/notificationReducer.js";
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SocketContext } from 'socket/SocketContext';
import { navbarIconButton } from './styles';
import { useMaterialUIController } from 'context';

const Notifications = () => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const notifications = useSelector((state) => state.notifications.notifications);
    const unreadCount = useSelector((state) => state.notifications.unreadCount);
    const anchorEl = useSelector((state) => state.notifications.anchorEl);

    const socket = useContext(SocketContext);
    const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({

    });


    useEffect(() => {
        socket?.emit('message', { businessUserID: loginDetails?.businessUserID });
        socket?.on('initialNotifications', (message) => {
            dispatch(setNotifications(message));
        });
        return () => {
            socket?.off('initialNotifications');

        };
    }, [socket, dispatch]);


    const handleOpenMenu = (event) => {
        socket?.emit('read', { businessUserID: loginDetails?.businessUserID, read: true });
        socket?.emit('message', { businessUserID: loginDetails?.businessUserID });
        dispatch(clearUnreadCount());
        dispatch(setAnchorEl(event.currentTarget));
    };

    const handleCloseMenu = () => {
        dispatch(resetAnchorEl());
    };

    const showNotification = (id, type) => {
        if (type === 'quotation') {
            navigate(`/quotations/view/${id}`);
        }
        if (type === 'invoice') {
            navigate(`/invoices/payment/${id}`);
        }
        dispatch(resetAnchorEl());
    };

    const handleClearAll = () => {
        socket?.emit('clearAll', { businessUserID: loginDetails?.businessUserID });
        dispatch(deleteNotification());
    };

    const renderMenu = () => (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
            sx={{ mt: -1 }}
            PaperProps={{ style: { width: 250 } }}
        >
            {notifications.length > 0 &&
                notifications.map((notification, index) => (
                    <MenuItem key={index} onClick={() => showNotification(notification.referenceID, notification.type)}>
                        <ListItemText style={{ whiteSpace: 'normal' }} primary={<h6>{notification.message}</h6>} />

                    </MenuItem>
                ))}
            <Divider />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1, mt: -2, mb: -2 }}>
                <Button size="small" onClick={handleClearAll}>
                    Clear All
                </Button>
            </Box>
        </Menu>
    );

    return (
        <>
            <Tooltip title="Notifications" arrow>
                <IconButton
                    size="medium"
                    sx={navbarIconButton}
                    aria-controls="notification-menu"
                    aria-haspopup="true"
                    variant="contained"
                    onClick={handleOpenMenu}
                    className={darkMode ? "darkPopup1" : "whitePopup1"}
                >
                    <Badge badgeContent={unreadCount} color="error">
                        <Icon sx={iconsStyle} >notifications</Icon>
                    </Badge>
                </IconButton>
            </Tooltip>
            {renderMenu()}
        </>
    );
};

export default Notifications;
